import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import { ResponseAddDto, ResponseEmpData, ResponseListingPerformanceEval, RequestGetEmp360Dto, ResponseSubmitRaterDto } from "../../../shared/nestjs/gd-integrated/dto/performance-evaluation.dto";
import { ResponsePerformance } from "../../../shared/nestjs/gd-integrated/dto/performance-planning.dto";
import { PerformanceEvaluationApi } from "../../../shared/nestjs/gd-integrated/services/performance-evaluation.api";

@Injectable()
export class PerformanceEvaluationBloc {

  constructor(
    public performanceEvaluationApi: PerformanceEvaluationApi
  ) {
  }

  add(data): Observable<ResponseAddDto> {
		return this.performanceEvaluationApi.add(data);
	}

  listing(params, page, limit): Observable<ResponseListingPerformanceEval> {
		return this.performanceEvaluationApi.listing(params, page, limit);
  }
  
  history(requestNo, periodCode, empId, referenceDate, formNo, planformno): Observable<any> {
		return this.performanceEvaluationApi.history(requestNo, periodCode, empId, referenceDate, formNo, planformno);
  }

  empData(periodCode, empId): Observable<ResponseEmpData> {
		return this.performanceEvaluationApi.empData(periodCode, empId);
  }

  evaluationHistory(empId, page, limit): Observable<any> {
		return this.performanceEvaluationApi.evaluationHistory(empId, page, limit);
  }

  answer360(periodCode, empId, raterEmpid): Observable<ResponseEmpData> {
		return this.performanceEvaluationApi.answer360(periodCode, empId, raterEmpid);
  }

  additionalNotes(periodCode, formNo, lstreviewer, referenceDate): Observable<any> {
		return this.performanceEvaluationApi.additionalNotes(periodCode, formNo, lstreviewer, referenceDate);
  }

  getEmp(payload: RequestGetEmp360Dto): Observable<any> {
    return this.performanceEvaluationApi.getEmp(payload);
  }

  submitRater(data): Observable<ResponseSubmitRaterDto> {
		return this.performanceEvaluationApi.submitRater(data);
	}

  performanceEvaluationRequest(requestNo): Observable<ResponsePerformance> {
		return this.performanceEvaluationApi.performancePlanRequest(requestNo);
  }

  threeSixtyQuestionHistory(periodCode, empId): Observable<ResponseEmpData> {
		return this.performanceEvaluationApi.threeSixtyQuestionHistory(periodCode, empId);
  }
}



// WEBPACK FOOTER //
// ./src/bloc/hr/performance-sf6/performance-evaluation.bloc.ts